// Combine sibling <em> and <s> elements
// If there is a span, move the content out of it. If there are plain text nodes in a span, put it in the proper tag

// Insert double brackets and pasting puts the spaces in the wrong places now ...
// Line numbers are different in different versions

export const alternativeNormalize = (P, keepMisspellings) => {
    const spans = keepMisspellings ?
        Array.from(P.getElementsByTagName('span')).filter(s => !(s.className.toLowerCase().includes('bracket') || s.className.toLowerCase().includes('spelling-error')))
        : Array.from(P.getElementsByTagName('span')).filter(s => !s.className.toLowerCase().includes('bracket'));
    for (let i = 0; i < spans.length; i++) {
        const span = spans[i];
        while (span.childNodes.length > 0) {
            const child = span.childNodes[0];
            if (child.nodeName.toLowerCase() === '#text') {
                if (span.className.toLowerCase().indexOf('msoins') > -1) {
                    const textNode = document.createTextNode(child.textContent);
                    const newEm = document.createElement('em');
                    newEm.appendChild(textNode);
                    span.before(newEm)
                    child.remove();
                } else if (span.className.toLowerCase().indexOf('msodel') > -1) {
                    const textNode = document.createTextNode(child.textContent);
                    const newS = document.createElement('S');
                    newS.appendChild(textNode);
                    span.before(newS)
                    child.remove();
                } else {
                    span.before(child);
                }
            } else if (child.nodeName === 'EM' || child.nodeName === 'I') {
                span.before(child);
            } else if (child.nodeName === 'U') {
                const newEm = document.createElement('em');
                newEm.appendChild(child);
                span.before(newEm);
                child.remove();
            } else if (child.nodeName === 'S') {
                span.before(child);
            } else {
                span.before(child);
            }
        }
        span.remove();
    }
    for (let i = 1; i < P.childNodes.length; i++) {
        const currentNode = P.childNodes[i];
        const prevNode = P.childNodes[i - 1];
        if (prevNode.nodeName === currentNode.nodeName) {
            if (prevNode.nodeName.toLowerCase() === '#text') {
                prevNode.textContent += currentNode.textContent;
                P.removeChild(currentNode);
                i--;
            } else if (prevNode.nodeName.toLowerCase() === 's') {
                for (let j = 0; j < currentNode.childNodes.length; j++) {
                    const child = currentNode.childNodes[j];
                    prevNode.appendChild(child);
                    j--;
                }
                P.removeChild(currentNode);
                i--;
            } else if (prevNode.nodeName.toLowerCase() === 'em') {
                for (let j = 0; j < currentNode.childNodes.length; j++) {
                    const child = currentNode.childNodes[j];
                    prevNode.appendChild(child);
                    j--;
                }
                P.removeChild(currentNode);
                i--;
            }
        }
    }
    P.normalize()
}

export const getNextSibling = (node) => {
    if (node?.nodeName === 'P') {
        return null;
    } else if (node?.nextSibling) {
        return getFirstChildest(node.nextSibling);
    } else if (node?.parentNode) {
        return getNextSibling(node.parentNode);
    } else {
        return null;
    }
}

export const getPreviousSibling = (node) => {
    if (node?.nodeName === 'P') {
        return null;
    } else if (node?.previousSibling) {
        return getLastChildest(node.previousSibling);
    } else if (node?.parentNode) {
        return getPreviousSibling(node.parentNode);
    } else {
        return null;
    }
}

export const currentlyInSpace = (range, whichEnd) => {
    const { startContainer, startOffset, endContainer, endOffset } = range;
    let rightIsSpace, leftIsSpace;
    let container, offset;
    if (whichEnd === 'start') {
        container = startContainer;
        offset = startOffset;
    } else {
        container = endContainer;
        offset = endOffset;
    }
    if (container.nodeName === '#text') {
        const textContent = container.textContent;
        if (offset === textContent.length) {
            // need to get the next sibling
            const nextSibling = getNextSibling(container);
            if (nextSibling) {
                rightIsSpace = nextSibling.textContent.charAt(0) === ' ';
            } else {
                rightIsSpace = ' ';
            }
        } else {
            rightIsSpace = textContent.charAt(offset) === ' ';
        }
        if (offset > 0) {
            leftIsSpace = textContent.charAt(offset - 1) === ' ';
        } else {
            const prevSibling = getPreviousSibling(container);
            if (prevSibling) {
                leftIsSpace = prevSibling.textContent.charAt(prevSibling.textContent.length - 1) === ' ';
            } else {
                leftIsSpace = ' ';
            }
        }
    } else if (startContainer.nodeName === 'P' && endContainer === startContainer && startOffset === endOffset && startOffset === 0 && startContainer.textContent === '') { // in an empty p ... ?
        return { leftIsSpace: ' ', rightIsSpace: ' ' };
    } else {
        const closest = closestParentOfType(container, 'p');
        if (closest?.textContent === '') {
            leftIsSpace = ' ';
            rightIsSpace = ' ';
        } else if (startContainer.nodeName === 'DIV') { // When inserting from clipboard and surrounding it with brackets ... only ?
            if (whichEnd === 'start') {
                leftIsSpace = true;
                rightIsSpace = false;
            } else {
                leftIsSpace = false;
                rightIsSpace = true;
            }
        } else {
            // ????
        }

    }
    return { leftIsSpace, rightIsSpace };
}

export const getFirstChildest = (element) => element.firstChild ? getFirstChildest(element.firstChild) : element;

export const getLastChildest = (element) => element.lastChild ? getLastChildest(element.lastChild) : element;

export const strikeContent = (range) => {
    let strikes = [];
    const { startContainer, startOffset, endContainer, endOffset } = range;
    const startIndex = getStartOfElement(startContainer, startOffset);
    const endIndex = getEndOfElement(startContainer, endOffset);
    if (startIndex > endIndex || startIndex < 0 || endIndex < 0) {
        alert('Please select a valid range.')
        return;
    } else {
        const spaceCount = startContainer.textContent.substring(startIndex, endIndex).split(' ').length - 1;
        if (spaceCount === 0) {
            const strike = document.createElement('s');
            strike.textContent = startContainer.textContent.substring(startIndex, endIndex);
            strikes.push(strike);
        } else {
            const split = startContainer.textContent.substring(startIndex, endIndex).split(' ');
            split.forEach((s, i) => {
                const strike = document.createElement('s');
                strike.textContent = s;
                strikes.push(strike);
            });
        }
        const newCurrentRange = document.getSelection().getRangeAt(0);
        const leftIsSpace = currentlyInSpace(newCurrentRange, 'start').leftIsSpace;
        const rightIsSpace = currentlyInSpace(newCurrentRange, 'end').rightIsSpace;
        const rightSpace = rightIsSpace ? '' : ' ';
        const leftSpace = leftIsSpace ? '' : ' ';
        const strikeText = strikes.map(s => s.outerHTML).join(' ');
        return { strikeText, leftSpace, rightSpace }
    }
}

export const insertFromClipboard = async (clean, editor, trim, checkForBrackets, dontIncludeEm) => {
    // Otherwise the paste result is counted as the initial state.
    if (!editor.undoManager.hasUndo() && !editor.undoManager.hasRedo()) {
        editor.undoManager.add();
    }
    const selecttion = window.getSelection();
    const range = selecttion.getRangeAt(0);
    const { startContainer, startOffset } = range;
    let text = '';
    const currentlyInSpaceResult = currentlyInSpace(range, 'start');
    if (clean) {
        const clipboardContents = await navigator.clipboard.read();
        for (const item of clipboardContents) {
            try {
                const plainText = await item.getType('text/plain');
                text = await plainText.text();
            } catch (e) {
                alert('No content found in clipboard');
                return;
            }
        }
        if (!text) {
            alert('No content retrieved from clipboard');
            return;
        }
        editor.insertContent(text)
    } else {
        const clipboardContents = await navigator.clipboard.read();
        // May need to prove nothing comes from a pdf
        console.log('Clipboard mime types:');
        clipboardContents.forEach(i => console.log(i.types));
        for (const item of clipboardContents) {
            try {
                const htmlText = await item.getType('text/html');
                text = await htmlText.text();
                console.log('HTML content found in clipboard:');
                console.log(text);
            } catch (e) {
                console.log(e);
                console.log('No HTML content found in clipboard, trying plain text');
                try {
                    const plainText = await item.getType('text/plain');
                    text = await plainText.text();
                    if (trim) {
                        editor.insertContent(text.trim())
                    } else {
                        editor.insertContent(text);
                    }
                    return; // Otherwise it inserts it again
                } catch (e) {
                    alert('No content found in clipboard');
                    return;
                }
            }
        }
        let containerDiv = document.createElement('div');
        // Empty p. Style appropriately.
        if (((currentlyInSpace.leftIsSpace === undefined && currentlyInSpace.rightIsSpace === undefined) || (currentlyInSpaceResult.leftIsSpace === ' ' && currentlyInSpaceResult.rightIsSpace === ' ')) &&
            (text.indexOf('<strong') > -1 || text.indexOf('<b') > -1) || (text.indexOf('<em') > -1 || text.indexOf('<i') > -1 || text.indexOf('<u') > -1)) {
            containerDiv.innerHTML = text;
            alternativeNormalize(containerDiv);
            containerDiv = removeHTMLComments(containerDiv);
            if (trim) {
                let firstChild = containerDiv.firstChild;
                while (firstChild.firstChild !== null) {
                    firstChild = firstChild.firstChild;
                }
                if (firstChild.textContent.charAt(0) === ' ') {
                    firstChild.textContent = firstChild.textContent.substring(1);
                }
                let lastChild = containerDiv.lastChild;
                while (lastChild.lastChild !== null) {
                    lastChild = lastChild.lastChild;
                }
                if (lastChild.textContent.charAt(lastChild.textContent.length - 1) === ' ') {
                    lastChild.textContent = lastChild.textContent.substring(0, lastChild.textContent.length - 1);
                }
            }
            const ps = containerDiv.getElementsByTagName('p');
            const closestP = closestParentOfType(startContainer, 'p');
            // Do I need the enactcls check?
            if ((text.indexOf('<strong') > -1 || text.indexOf('<b') > -1) && (ps.length === 0 || !Array.from(ps).find(p => p.className.includes('enactcls')))) {
                if (closestP?.className === 'enactcls') {
                    if (dontIncludeEm && range.startContainer.nodeName === 'EM') {
                        range.startContainer.before(document.createTextNode(containerDiv.textContent));
                        range.startContainer.remove();
                    } else {
                        editor.insertContent(containerDiv.textContent);
                    }
                } else if (closestP?.className === 'catchln') {
                    editor.insertContent(containerDiv.textContent);
                } else {
                    const newP = document.createElement('p');
                    newP.className = 'enactcls';
                    newP.innerHTML = containerDiv.innerHTML;
                    editor.insertContent(newP.outerHTML);
                }
            } else if ((text.indexOf('<em') > -1 || text.indexOf('<i') > -1 || text.indexOf('<u') > -1) && containerDiv.innerHTML.indexOf('<em') < 0) {
                if (!dontIncludeEm) {
                    containerDiv.innerHTML = `<em>${containerDiv.innerHTML}</em>`;
                }
                alternativeNormalize(containerDiv);
                editor.insertContent(containerDiv.innerHTML);
            } else {
                editor.insertContent(containerDiv.innerHTML);
            }
            if (checkForBrackets) {
                const newRange = document.getSelection().getRangeAt(0);
                const newClosestP = closestParentOfType(newRange.startContainer, 'P');
                if (newClosestP && newClosestP.className === 'enactcls' && newClosestP.previousSibling.textContent === ('[ ' + zeroWidthSpace) && newClosestP.nextSibling.textContent === ' ]') {
                    const newStartSpan = document.createElement('span');
                    newStartSpan.className = 'bracket';
                    newStartSpan.textContent = '[';
                    newClosestP.insertBefore(document.createTextNode(' '), newClosestP.firstChild);
                    newClosestP.insertBefore(newStartSpan, newClosestP.firstChild);
                    const newEndSpan = document.createElement('span');
                    newEndSpan.className = 'bracket';
                    newEndSpan.textContent = ']';
                    newClosestP.appendChild(document.createTextNode(' '));
                    newClosestP.appendChild(newEndSpan);
                    newClosestP.previousSibling.remove();
                    newClosestP.nextSibling.remove();
                }
            }
            editor.undoManager.add();
        } else {
            // If the source has italics, underline, or em tags, we need to make sure the destination does too.
            if (text.indexOf('</em>') > -1 || text.indexOf('</i>') > -1 || text.indexOf('</u>') > -1) {
                const closestP = closestParentOfType(startContainer, 'p');
                const closestEm = closestParentOfType(startContainer, 'em');
                const alreadyItalic = closestEm || closestP.className === 'ldtitle';
                containerDiv.innerHTML = text;
                alternativeNormalize(containerDiv);
                containerDiv = removeHTMLComments(containerDiv);
                if (trim) {
                    let firstChild = containerDiv.firstChild;
                    while (firstChild.firstChild !== null) {
                        firstChild = firstChild.firstChild;
                    }
                    if (firstChild.textContent.charAt(0) === ' ') {
                        firstChild.textContent = firstChild.textContent.substring(1);
                    }
                    let lastChild = containerDiv.lastChild;
                    while (lastChild.lastChild !== null) {
                        lastChild = lastChild.lastChild;
                    }
                    if (lastChild.textContent.charAt(lastChild.textContent.length - 1) === ' ') {
                        lastChild.textContent = lastChild.textContent.substring(0, lastChild.textContent.length - 1);
                    }
                }

                const content = (alreadyItalic || dontIncludeEm) ? containerDiv.innerHTML : `<em>${containerDiv.innerHTML}</em>`;
                editor.insertContent(content);
                editor.undoManager.add();
            } else { // Otherwise, paste mostly as is. Remove the tags
                containerDiv.innerHTML = text;
                alternativeNormalize(containerDiv);
                containerDiv = removeHTMLComments(containerDiv);
                if (trim) {
                    let firstChild = containerDiv.firstChild;
                    while (firstChild.firstChild !== null) {
                        firstChild = firstChild.firstChild;
                    }
                    if (firstChild.textContent.charAt(0) === ' ') {
                        firstChild.textContent = firstChild.textContent.substring(1);
                    }
                    let lastChild = containerDiv.lastChild;
                    while (lastChild.lastChild !== null) {
                        lastChild = lastChild.lastChild;
                    }
                    if (lastChild.textContent.charAt(lastChild.textContent.length - 1) === ' ') {
                        lastChild.textContent = lastChild.textContent.substring(0, lastChild.textContent.length - 1);
                    }
                }
                editor.insertContent(containerDiv.innerHTML.replaceAll('\n', ''));
                editor.undoManager.add();
            }
        }
    }
}

const getStartOfElement = (node, possibleStart) =>
    node.textContent.charAt(possibleStart) !== ' ' ? possibleStart :
        node.textContent.charAt(possibleStart + 1) !== ' ' ? possibleStart + 1 : -1;

const getEndOfElement = (node, possibleEnd) => // End index is not inclusive
    [' ', ''].includes(node.textContent.charAt(possibleEnd)) ? possibleEnd :
        [' ', ''].includes(node.textContent.charAt(possibleEnd - 1)) ? possibleEnd - 1 : -1;

export const zeroWidthSpace = '\u200B';

export const closestParentOfType = (node, type) => {
    if (!node || node.nodeName === 'DIV') {
        return null;
    } else if (node.nodeName.toLowerCase() === type.toLowerCase()) {
        return node;
    } else {
        return closestParentOfType(node.parentNode, type);
    }
}

const removeHTMLComments = el => {
    const ps = el.getElementsByTagName('p');
    const toReturn = document.createElement('div');
    if (ps.length > 0) {
        for (let i = 0; i < ps.length; i++) {
            const newP = document.createElement('p');
            if (ps[i].innerHTML.indexOf('<strong') > -1 || ps[i].innerHTML.indexOf('<b') > -1) {
                newP.className = 'enactcls';
                if (ps[i].childNodes[0].nodeName === 'STRONG' || ps[i].childNodes[0].nodeName === 'B') {
                    while (ps[i].childNodes[0].childNodes.length > 0) {
                        newP.appendChild(ps[i].childNodes[0].childNodes[0]);
                    }
                } else {
                    newP.innerHTML = ps[i].innerHTML;
                    newP.className = 'section';
                }
            } else if (ps[i].innerHTML.indexOf('<em') > -1 || ps[i].innerHTML.indexOf('<i') > -1 || ps[i].innerHTML.indexOf('<u') > -1) {
                newP.className = 'section';
                newP.innerHTML = '<em>' + ps[i].innerHTML.replaceAll('<i>', '').replaceAll('</i>', '').replaceAll('<em>', '').replaceAll('</em>', '').replaceAll('<u>', '').replaceAll('</u>', '') + '</em>';
            } else {
                newP.className = 'section';
                newP.innerHTML = ps[i].innerHTML;
            }
            toReturn.appendChild(newP);
        }
        return toReturn
    }
    if (ps.length === 0) {
        const child = getFirstNonDivElement(el);
        const presumedParent = child?.parentNode;
        if (presumedParent) {
            // Yay firefox comments
            toReturn.innerHTML = presumedParent.innerHTML.replaceAll('\n', '').replaceAll('<!--StartFragment-->', '').replaceAll('<!--EndFragment-->', '');
            if (toReturn.childNodes.length === 1 && toReturn.firstChild.nodeName === 'STRONG') {
                const newP = document.createElement('p');
                newP.className = 'enactcls';
                newP.innerHTML = toReturn.firstChild.innerHTML;
                toReturn.innerHTML = newP.outerHTML;
            }
        }
        else {
            toReturn.textContent = el.textContent;
        }
    }
    let textContent = toReturn.textContent;
    textContent = textContent.replaceAll(/<ul.+?>/g, '').replaceAll(/<\/ul>/g, '');
    toReturn.textContent = textContent;
    return toReturn;
}

const removeTags = el => {
    let node = el.firstChild;
    while (node) {
        if (!['span', 'A',].includes(node.nodeName)) {
            for (let j = 0; j < node.childNodes.length; j++) {
                el.insertBefore(node.childNodes[j], node);
                j--;
            }
            if (node.nextSibling) {
                node = node.nextSibling;
                el.removeChild(node.previousSibling);
            } else {
                el.removeChild(node);
                break;
            }
        } else {
            // node = node.nextSibling;
        }
    }
    el.normalize();
    return el;
}

export const generateNodeArray = (startContainer, startOffset, parentP) => {
    const nodeArray = [];
    let el = startContainer;
    let index = startOffset;
    while (el !== parentP) {
        nodeArray.push({ el, index });
        const c = el;
        el = el.parentNode;
        index = Array.from(el.childNodes).indexOf(c);
    }
    nodeArray.push({ el, index });
    return nodeArray.reverse();
}

export const isFirefox = navigator.userAgent.indexOf('Firefox') > -1;

const getFirstNonDivElement = (container) => {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: node => node.nodeName.toLowerCase() !== 'div' ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
    });
    return walker.nextNode();
}

export const currentlyInEm = (startContainer) => startContainer.nodeName === 'EM' || startContainer.parentElement?.nodeName === 'EM';

export const generateRangeFromNodeArray = (nodeArray, closestP) => {
    const backToRange = document.createRange();
    let startNode = closestP;
    for (let i = 0; i < nodeArray.length - 1; i++) {
        startNode = startNode.childNodes[nodeArray[i].index];
    }
    backToRange.setStart(startNode, nodeArray[nodeArray.length - 1].index);
    backToRange.setEnd(startNode, nodeArray[nodeArray.length - 1].index);
    return backToRange;
}

// The first implementation wouldn't go multiple layers deep.
const splitHtmlAtCursor = (range) => {

    const fragmentToHtml = (fragment) => {
        const div = document.createElement('div');
        div.appendChild(fragment);
        return div.innerHTML;
    }

    const beforeRange = range.cloneRange();
    const afterRange = range.cloneRange();
    const p = closestParentOfType(range.startContainer, 'P');

    beforeRange.setStart(p, 0);
    beforeRange.setEnd(range.startContainer, range.startOffset);

    afterRange.setStart(range.endContainer, range.endOffset);
    afterRange.setEndAfter(p.lastChild);

    const beforeFragment = beforeRange.cloneContents();
    const afterFragment = afterRange.cloneContents();

    return {
        beforeHtml: fragmentToHtml(beforeFragment),
        afterHtml: fragmentToHtml(afterFragment)
    };
}

export const insertBracket = (editor, bracket) => {
    if (!editor.undoManager.hasUndo() && !editor.undoManager.hasRedo()) {
        editor.undoManager.add();
    }
    const currentRange = editor.selection.getRng();
    const { leftIsSpace, rightIsSpace } = currentlyInSpace(currentRange, 'start');
    const parentP = closestParentOfType(currentRange.startContainer, 'p');
    const splitContent = splitHtmlAtCursor(currentRange);
    const leftSpace = leftIsSpace ? '' : ' ';
    const rightSpace = rightIsSpace === true ? '' : ' ';
    const timestamp = new Date().getTime()
    parentP.innerHTML = splitContent.beforeHtml + leftSpace + `<span class="bracket">${bracket}</span>` + rightSpace + `<span id=${timestamp}></span>` + splitContent.afterHtml;
    const empty = document.getElementById(timestamp);
    const newRange = document.createRange();
    if (!rightIsSpace) {
        newRange.setStart(empty, 0);
        newRange.setEnd(empty, 0);
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(newRange);
        empty.remove();
    } else { // Have to find where to put the cursor if you can't put it after the new space.
        let nextSibling = getNextSibling(empty);
        while (nextSibling && !nextSibling.textContent) { // wtf empty tags. I've only seen this one level deep/siblings, but whatever.
            nextSibling.remove();
            nextSibling = getNextSibling(empty);
        }
        if (nextSibling && nextSibling.nodeName === '#text' && nextSibling.textContent.length > 0) {
            newRange.setStart(nextSibling, 1);
            newRange.setEnd(nextSibling, 1);
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(newRange);
            empty.remove();
        } else {
            newRange.setStart(empty, 0);
            newRange.setEnd(empty, 0);
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(newRange);
            empty.remove();
        }
    }
    editor.undoManager.add();
}

export const insertBrackets = (editor, paste) => {
    if (!editor.undoManager.hasUndo() && !editor.undoManager.hasRedo()) {
        editor.undoManager.add();
    }
    const currentRange = editor.selection.getRng();
    const { leftIsSpace, rightIsSpace } = currentlyInSpace(currentRange, 'start');
    const parentP = closestParentOfType(currentRange.startContainer, 'p');
    const splitContent = splitHtmlAtCursor(currentRange);
    const leftSpace = leftIsSpace ? '' : ' ';
    const rightSpace = rightIsSpace === true ? '' : ' ';
    const timestamp = new Date().getTime()
    parentP.innerHTML = splitContent.beforeHtml + leftSpace + `<span class="bracket">[</span> <em id=${timestamp}>${zeroWidthSpace}</em> <span class="bracket">]</span>` + rightSpace + `<span id=${timestamp + 1}></span>` + splitContent.afterHtml;
    const em = document.getElementById(timestamp);
    const newRange = document.createRange();
    newRange.setStart(em, 1);
    newRange.setEnd(em, 1);
    em.removeAttribute('id');
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(newRange);
    const empty = document.getElementById(timestamp + 1);
    let nextSibling = getNextSibling(empty);
    while (nextSibling && !nextSibling.textContent) { // wtf empty tags. I've only seen this one level deep/siblings, but whatever.
        nextSibling.remove();
        nextSibling = getNextSibling(empty);
    }
    empty.remove();
    editor.undoManager.add();
    if (paste) {
        insertFromClipboard(false, editor, true, true, true);
    }
}

/**
 This doesn't get the whole part of a text node, just the part that is selected.
Not an issue with the implementation, but just good to know.
*/
const getSelectedNodes = async (selection) => {
    const nodeList = [];
    const fragment = document.createDocumentFragment();

    for (let i = 0; i < selection.rangeCount; i++) {
        fragment.append(selection.getRangeAt(i).cloneContents());
    }

    const walker = document.createTreeWalker(fragment);

    while (walker.nextNode()) {
        const currentNode = walker.currentNode;
        nodeList.push(currentNode);
    }

    return nodeList;
}

export const removeSpellingErrors = (parent, callback) => {
    const spans = parent.querySelectorAll('.spelling-error');
    if (spans.length > 0) {
        Array.from(spans).forEach(s => {
            Array.from(s.childNodes)
                .forEach(sc => s.before(sc));
            s.remove();
        })
        parent.normalize();
        callback && callback();
    }
}

export const getEditorContent = (callback) => {
    const editorContainer = document.getElementById('editor-container');
    let editorText = '';
    removeSpellingErrors(editorContainer, callback);
    Array.from(editorContainer.children).forEach(child => Array.from(child.children).forEach(pOrDiv => {
        if (pOrDiv.id === 'header-content' || pOrDiv.nodeName === 'TABLE') {
            editorText += pOrDiv.outerHTML.replaceAll(zeroWidthSpace, '')
                .replaceAll(/data-mce-href=".*?"/g, '').replaceAll(/data-mce-selected=".*?"/g, '').replaceAll(/data-mce-style=".*?"/g, '');
        } else {
            editorText += pOrDiv.outerHTML.replaceAll(zeroWidthSpace, '')
                .replaceAll(/data-mce-href=".*?"/g, '').replaceAll(/data-mce-selected=".*?"/g, '').replaceAll(/data-mce-style=".*?"/g, '').replaceAll(/style=".*?"/g, '');
        }
    }));
    return editorText;
}

export const goToLine = lineNumber => {
    let found = false;
    const lineNumberHolder = document.getElementById('other-line-numbers');
    const walker = document.createTreeWalker(lineNumberHolder, NodeFilter.SHOW_TEXT);
    let node;
    while (node = walker.nextNode()) {
        const lineIndex = node.textContent.indexOf(lineNumber);
        if (lineIndex > -1) {
            found = true;
            const range = document.createRange();
            range.setStart(node, lineIndex);
            range.setEnd(node, lineIndex + ('' + lineNumber).length);
            const sel = document.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            node.parentElement.scrollIntoView();
            break;
        }
    }
    if (!found) { // Assume that its at the end of a previous version, so go to the end of this one.
        window.scroll(0, document.body.scrollHeight)
    }
}
